import { render, staticRenderFns } from "./ShowOrganizations.vue?vue&type=template&id=566e0f51&"
import script from "./ShowOrganizations.vue?vue&type=script&lang=js&"
export * from "./ShowOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports